import React, { useContext, VFC } from 'react';

import classNames from 'classnames';
import { Text } from 'mintel-react-ui';

import { DangerousH4, DangerousSpan } from '../../components/common';
import { Present, ProductContainerJson } from '../../types';
import { Asset, assetUri } from '../../utils/assetUri';
import { PresentModeContext, PublishStatusContext } from '../../utils/contexts';
import { IMAGE_SIZE } from './MediaColumn';
import styles from './ProductColumn.scss';

type ProductColumnProps = Pick<ProductContainerJson, 'elements'> & {
  description?: string;
  expand?: boolean;
  hide?: boolean;
};

export const ProductColumn: VFC<ProductColumnProps> = ({
  elements,
  description,
  expand = false,
  hide = false,
}) => {
  const publishStatus = useContext(PublishStatusContext);
  const presentMode = useContext(PresentModeContext);
  const source = elements.image.source;
  // TODO: Placeholder for missing images? rather than crashing
  const backgroundUrl = source?.startsWith('workspace_SpacesStore')
    ? assetUri(source, Asset.Image, publishStatus)
    : source;

  return (
    <div
      className={classNames(styles['product-container'], {
        [styles[presentMode || '']]: presentMode === Present.Keynote,
        [styles['present-mode']]: !!presentMode,
        [styles.expand]: expand,
        [styles.hide]: hide,
      })}
    >
      <img
        src={backgroundUrl}
        className={styles['product-image']}
        alt="product"
        style={{ aspectRatio: IMAGE_SIZE.SMALL.aspect }}
        width={IMAGE_SIZE.SMALL.width}
      />
      <div className={styles['product-title']}>
        <Text.Heading4 darkBg>
          <DangerousH4>{elements.title.content}</DangerousH4>
        </Text.Heading4>
        {description && (
          <div className={styles['product-description']}>
            <Text.Body darkBg underlineLinks>
              <DangerousSpan>{description}</DangerousSpan>
            </Text.Body>
          </div>
        )}
      </div>
    </div>
  );
};
